import styled from 'styled-components';
import { color } from 'styles/colors';

export const container = styled.div`
  width: 100%;
  display: flex;
  gap: 5px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const productsContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 5px;
  flex-direction: row;
  overflow: auto;

  ::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
`;

export const product = styled.div`
  max-width: 47%;
  min-width: 47%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border: 1px solid ${color.interface.lightGray2};
  border-radius: 10px;
  padding: 10px;

  > img {
    width: 100%;

    object-fit: contain;
  }

  > p {
    width: 100%;
    font-size: 15px;
    color: ${color.interface.darkgray};
    font-weight: 900;
  }

  > h2 {
    font-size: 12px;
    color: ${color.interface.darkgray};
  }

  > svg {
    align-self: flex-end;
    font-size: 20px;
    color: ${color.interface.greenSuperXtra};
  }
`;

export const btnBuy = styled.div`
  width: 100%;
  padding: 5px;
  background-color: ${color.interface.greenSuperXtra};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;

  > p {
    text-align: center;
    font-size: 10px;
    font-weight: 700;
    color: ${color.interface.white};
  }
`;

export const noProducts = styled.div`
  width: 100%;
  height: 10vh;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
